import {
  // Frontend
  SiHtml5,
  SiCss3,
  SiJavascript,
  SiTypescript,
  SiReact,
  SiNextdotjs,
  SiTailwindcss,
  SiRedux,
  SiVuedotjs,
  SiSass,
  SiWebpack,
  SiVite,

  // Backend
  SiNodedotjs,
  SiExpress,
  SiNestjs,
  SiLaravel,
  SiPython,
  SiDjango,
  SiFastapi,
  SiSpringboot,
  SiPhp,

  // Databases
  SiMongodb,
  SiPostgresql,
  SiMysql,
  SiFirebase,
  SiRedis,
  SiSqlite,
  SiSupabase,

  // Mobile
  SiFlutter,
  SiAndroid,
  SiSwift,
  SiKotlin,

  // Cloud & DevOps
  SiAmazonaws,
  SiGooglecloud,
  SiMicrosoftazure,
  SiDocker,
  SiKubernetes,
  SiNginx,
  SiGithubactions,
  SiTerraform,
  SiJenkins,

  // Testing
  SiJest,
  SiCypress,
  SiTestinglibrary,

  // CMS & E-Commerce
  SiWordpress,
  SiStrapi,
  SiShopify,

  // Design
  SiFigma,
  SiSketch,
  SiFramer,

  // Analytics & Monitoring
  SiGoogleanalytics,
  SiGrafana,
  SiPrometheus,

  // AI / Automation
  SiOpenai,
} from "react-icons/si";

import { SiReact as SiReactNative } from "react-icons/si";

// ================= FRONTEND =================
export const frontendTech = [
  { name: "HTML5", icon: SiHtml5 },
  { name: "CSS3", icon: SiCss3 },
  { name: "JavaScript", icon: SiJavascript },
  { name: "TypeScript", icon: SiTypescript },
  { name: "React", icon: SiReact },
  { name: "Next.js", icon: SiNextdotjs },
  { name: "Vue.js", icon: SiVuedotjs },
  { name: "Tailwind CSS", icon: SiTailwindcss },
  { name: "Sass", icon: SiSass },
  { name: "Redux", icon: SiRedux },
  { name: "Webpack", icon: SiWebpack },
  { name: "Vite", icon: SiVite },
];

// ================= BACKEND =================
export const backendTech = [
  { name: "Node.js", icon: SiNodedotjs },
  { name: "Express.js", icon: SiExpress },
  { name: "NestJS", icon: SiNestjs },
  { name: "Laravel", icon: SiLaravel },
  { name: "PHP", icon: SiPhp },
  { name: "Python", icon: SiPython },
  { name: "Django", icon: SiDjango },
  { name: "FastAPI", icon: SiFastapi },
  { name: "Spring Boot", icon: SiSpringboot },
];

// ================= MOBILE =================
export const mobileTech = [
  { name: "React Native", icon: SiReactNative },
  { name: "Flutter", icon: SiFlutter },
  { name: "Android", icon: SiAndroid },
  { name: "Kotlin", icon: SiKotlin },
  { name: "iOS (Swift)", icon: SiSwift },
];

// ================= DATABASE =================
export const databaseTech = [
  { name: "MongoDB", icon: SiMongodb },
  { name: "PostgreSQL", icon: SiPostgresql },
  { name: "MySQL", icon: SiMysql },
  { name: "SQLite", icon: SiSqlite },
  { name: "Redis", icon: SiRedis },
  { name: "Firebase", icon: SiFirebase },
  { name: "Supabase", icon: SiSupabase },
];

// ================= CLOUD & DEVOPS =================
export const cloudTech = [
  { name: "AWS", icon: SiAmazonaws },
  { name: "Google Cloud", icon: SiGooglecloud },
  { name: "Microsoft Azure", icon: SiMicrosoftazure },
  { name: "Docker", icon: SiDocker },
  { name: "Kubernetes", icon: SiKubernetes },
  { name: "Nginx", icon: SiNginx },
  { name: "GitHub Actions", icon: SiGithubactions },
  { name: "Terraform", icon: SiTerraform },
  { name: "Jenkins", icon: SiJenkins },
];

// ================= DESIGN =================
export const designTech = [
  { name: "Figma", icon: SiFigma },
  { name: "Sketch", icon: SiSketch },
  { name: "Framer", icon: SiFramer },
];

export const testingTech = [
  { name: "Jest", icon: SiJest },
  { name: "Cypress", icon: SiCypress },
  { name: "Testing Library", icon: SiTestinglibrary },
];

export const cmsTech = [
  { name: "WordPress", icon: SiWordpress },
  { name: "Strapi", icon: SiStrapi },
  { name: "Shopify", icon: SiShopify },
];

export const analyticsTech = [
  { name: "Google Analytics", icon: SiGoogleanalytics },
  { name: "Grafana", icon: SiGrafana },
  { name: "Prometheus", icon: SiPrometheus },
];

export const aiTech = [{ name: "OpenAI APIs", icon: SiOpenai }];
